import { PERMISSION_MESSAGE_MAP } from '../permissions';
import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';
import routes from './routes';

Vue.use(Router);

export function createRouter(){
  const router = new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes
  });

  let nextPath = '/dashboard';
  let authUser;

  router.beforeEach(async (to, from, next) => {
    if(to.name === 'login' || to.name === 'Verify Account')
      return next();

    authUser = store.state.authUser;
    if(!authUser){
      // redirect to this path after login
      nextPath = to.path;

      store.subscribe((mutation, state) => {
        if(mutation.type === 'SET_AUTH_USER'){
          if(state.authUser)
            router.replace(nextPath);
          else
            router.replace('/login')
        }
      });

      return next('/login');
    }
    else if(!authUser.verifiedAt){
      if(to.path !== '/not-verified')
        return next('/not-verified');
    }
    else if(authUser.staffFirstTimeLoginFlag !== 1){
      if(to.path !== '/change-password')
        return next('/change-password');
    }
    else if(authUser.staffApprovalStatus !== 1 && to.path !== '/not-verified'){
      return next('/not-verified');
    }
    // else if(authUser.roleApprovalStatus !== 1 && to.path !== '/role-not-approved'){
    //   return next('/role-not-approved');
    // }
    else{
      if(!to.meta || !to.meta.permissions)
        return next();

      const authUserPermissions = authUser.permissions.map(p => p.genericName);
      const routePermissions = to.meta.permissions;
      const missingPermissions = routePermissions.filter(permission => authUserPermissions.indexOf(permission) === -1);

      if(missingPermissions.length > 0){
        const firstMissingPermission = missingPermissions[0];
        store.commit('SET_NOT_ALLOWED_MESSAGE', PERMISSION_MESSAGE_MAP[firstMissingPermission]);
        return next('/403');
      }
    }

    next();
  });

  return router;
}

const router = createRouter();

export default router;
